import { useState } from "react";
import DateInput from "../../../components/common/inputs/DateInput";
export default function AllUserCommisionsReportsFilter({
  filterDataHandler,
  activeSearchButton,
}) {
  const [filters, setFilters] = useState({});

  const handleSearchClick = () => {
    filterDataHandler({ page: 1, ...filters });
  };
  return (
    <div className="w-full flex flex-row flex-wrap my-8 gap-6 px-6">
      <DateInput
        label={"از تاریخ"}
        onChange={(e) => setFilters((prev) => ({ ...prev, from: e }))}
      />
      <DateInput
        label={"تا تاریخ"}
        onChange={(e) => setFilters((prev) => ({ ...prev, to: e }))}
      />
      <button
        disabled={!activeSearchButton}
        onClick={handleSearchClick}
        className="text-white mt-[30px] h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        {activeSearchButton ? "جستجو" : "منتظر بمانید..."}
      </button>
    </div>
  );
}
